module.exports = __webpack_public_path__ + "img/jiaodian.61a796e1.png";